/**
 * Autogenerated file don't modify
 *
 * Generated on: 2020-07-08T10:18:41.860Z
 * Generated by: arnar
 */
(function () {
(function () {
	'use strict';

	/**
	 * Autogenerated file don't modify
	 *
	 * Generated on: 2020-05-13T16:31:47.120Z
	 * Generated by: arnarb
	 */

	var empFilter = (function ($) {
		var $empFilter,
			init = function () {
				$empFilter = $('.filterControls', '#employees');
				if ($empFilter.length > 0) {
					empFilter.main.init();
				}
			};
		$(document).ready(init);
		return {
			$: $,
			g: function () {
				return $empFilter.closest('.box');
			}
		};
	})(jQuery);

	empFilter.main = (function (parent) {
		var $ = parent.$,
			$form,
			$input,
			$select,
			$link,
			$list,
			$content,
			init = function () {
				$list = parent.g().find('.employee__single');
				$content = parent.g().find('.content');
				jQuery.expr[':'].startsWith = function (a, i, m) {
					//noinspection JSConstructorReturnsPrimitive
					var t = $(a).text().replace(/^\s*/, '').substring(0, 1);
					return (t || "").toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
				};
				jQuery.expr[':'].containsIC = function (a, i, m) {
					var t = $(a).text();
					return (t || "").toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
				};
				$('#employees .linksFilter a.all').addClass('selected');
				initAlphaFilter();
				initSearch();
			},

			initAlphaFilter = function() {
				var $alphaFilter = parent.g().find('.alphaFilter');
				if ($alphaFilter.length > 0) {
					$('a', $alphaFilter).each(function() {
						var char = $(this).data('char');
						if ($list.find('.title:startsWith("' + char + '")').length === 0) {
							$('span', $(this)).unwrap();
						}
					});
				}
			},

			initSearch = function () {
				$form = parent.g().find('form');
				$form.on('submit', function(e) {
					e.preventDefault();
				});
				$input = $form.find('input').keyup(function (e) {
					//if (e.which == 13) { // Enter
					var t = this;
					doSearch.call(t);
					//}
				});
				$select = $form.find('select').change(doSearch);
				$link = $form.find('a').click(doSearch);

				//TODO: use selectedHash to filter on load
				//var hash = location.hash.slice(1);
				//var selectedHash = hash.length > 0 ? hash : '';
			},
			doSearch = function (e) {
				$('.branchTitle').removeClass('hide');

				if (e) {
					e.preventDefault();
				}
				var $this = $(this),
					$res = $list,
					t = this.tagName;

				//Select
				if (t === 'SELECT') {
					$link.removeClass('selected');

					var selectValue = $select.val();
					if (selectValue) {
						$res = $res.filter('.' + selectValue);
					}
					setHash(selectValue);
				}

				//Searching
				else if (t === 'INPUT') {
					$link.removeClass('selected');

					var searchValue = $input.val();
					if (searchValue) {
						$res = $res.find(':containsIC("' + searchValue + '")').parent();
					}
				}

				//Clicking
				else {
					if ($this.hasClass('all')) {
						$link.removeClass('selected');
						$select.prop('selectedIndex', 0);
					}
					if ($this.hasClass('selected') && !$this.hasClass('all')) {
						$link.removeClass('selected');
					}
					else {
						$link.removeClass('selected');
						$this.addClass('selected');
					}

					var linkHref = $link.filter('.selected').attr('href');
					linkHref = linkHref ? linkHref.replace('#', '') : '';

					if (linkHref) {
						linkHref = linkHref.replace('#', '');

						if ($this.parent().hasClass('linksFilter')) {
							$res = $res.filter('.' + linkHref);
						}
					}
					else if ($this.data('char') && $this.data('char').length > 0) {
						$select.prop('selectedIndex', 0);
						if ($this.hasClass('selected')) {
							var selectedAlpha = $this.data('char');
							$res = $res.find('.title:startsWith("' + selectedAlpha + '")').closest('.employee__single');
						}
						else {
							linkHref = '';
						}
					}

					setHash(linkHref);
				}
				result($res);
			},

			result = function ($filtered) {
				if ($filtered) {
					$list.addClass('hide').removeClass('open');
					$filtered.removeClass('hide');
					$content.addClass('hidden');
					$('div.staff').each(function() {
						if ($('.employee__single:not(.hide)', $(this)).length === 0) {
							$(this).parent().addClass('hide');
						}
						else {
							$(this).parent().removeClass('hide');
						}
					});
				}
				else {
					$list.removeClass('hide');
				}
			},

			setHash = function(hash) {
				var scrollTop = $(window).scrollTop() ;
				location.hash = hash;
				window.scrollTo(0, scrollTop);
			};
		return {
			init: init
		};
	})(empFilter);

}());
typeof tsBuild === 'function' && tsBuild();})();
